export default __webpack_public_path__ + "static/media/skirt_1.e2692c83.jpg";